import styled from 'styled-components';

export const SplashSliderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const SliderWrapper = styled.div`
    display: flex;
    width: 90%;
    padding-right: 0.5rem;

    input[type='range'] {
        width: 100%;
        cursor: pointer;
        margin: 0.75rem 0.5rem 0.5rem 0.5rem;
        outline: none;
        padding: 0;
        -webkit-appearance: none;
        -moz-appearance: none;
    }

    input[type='range']::-webkit-slider-runnable-track {
        width: 100%;
        height: 4px;
        background: ${({ theme }) => theme.palette.grayscale.gray10};
        border-radius: 4px;
        border: 1px solid ${({ theme }) => theme.palette.grayscale.gray10};
        margin-top: 0.5rem;
        z-index: 1;
    }

    input[type='range']::-moz-range-track {
        width: 100%;
        height: 4px;
        background: ${({ theme }) => theme.palette.grayscale.gray10};
        border-radius: 4px;
        border: 1px solid ${({ theme }) => theme.palette.grayscale.gray10};
        margin-top: 0.5rem;
        z-index: 1;
    }

    input[type='range']::-webkit-slider-thumb {
        -webkit-appearance: none;
        -moz-appearance: none;
        height: 1rem;
        width: 1rem;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.palette.primary.main};
        margin-top: -0.45rem;
        box-shadow: none;
    }
    input[type='range']::-moz-range-thumb {
        -webkit-appearance: none;
        -moz-appearance: none;
        height: 1rem;
        width: 1rem;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.palette.primary.main};
        margin-top: -0.45rem;
        box-shadow: none;
    }
`;

export const InputWrapper = styled.div`
    width: 30%;
`;
